import { VOverlay } from 'vuetify/lib/components/VOverlay';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[(_vm.report)?_c('report-viewer',{attrs:{"closable":false,"report":_vm.report,"task":_vm.report.scheduled_report}}):_c(VOverlay,{staticClass:"text-center pa-10",attrs:{"z-index":"1000"}},[_c('img',{staticClass:"spin",staticStyle:{"height":"150px"},attrs:{"src":_vm.api.url + '/img/logo.png'}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }